import { render, staticRenderFns } from "./KeywordManager.vue?vue&type=template&id=2f3a4a0c&scoped=true"
import script from "./KeywordManager.vue?vue&type=script&lang=js"
export * from "./KeywordManager.vue?vue&type=script&lang=js"
import style0 from "./KeywordManager.vue?vue&type=style&index=0&id=2f3a4a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a4a0c",
  null
  
)

export default component.exports